
import {AbstractUI} from "./AbstractUI";
import bidello,{component} from "bidello";

export class NavigationDrawer extends component(AbstractUI){

    init(){

        this.triggers = [];

    }

    onStateChange(state){

        if (state.state == "navigation-open-state")this.domElement.classList.add('open');
        if (state.state == "navigation-close-state")this.domElement.classList.remove('open');
        if (state.state == "navigation-toggle-state")this.domElement.classList.toggle('open');


    }



}